export class DayPelletizingProductQuality {
    constructor({
          id= null,       
          day= ``,
          code='',
          locName= ``,  
          productName= ``,
         
      } = {}) {
      this.id = id;  
      this.code=code;    
      this.day = day;
      this.locName = locName;     
      this.productName = productName;
    
    }
  }
  export function gridFields() {
    return Object.freeze([  
      {
        key: 'code',
        label: 'lbl.basic.code',
        sortable: true,
        form: {
          type: 'input'
        }
      },
        {
          key: 'locName',
          label: 'lbl.basic.locName',
          sortable: true,
          form: {
            type: 'input'
          }
        }, 
        {
          key: 'day',
          label: 'lbl.basic.day',
          sortable: true,
          form: {
            type: 'datepicker'
          }
        },                            
        {
          key: 'productName',
          label: 'lbl.prd.execution.productionName',
          sortable: false,
          form: {
            type: 'input'
          }
        }, 
       
    ]);
  }
  export const fields = Object.freeze(Object.keys(new DayPelletizingProductQuality()).map(i => 'entity.' + i));
  export const filterFields = [
    'filter.plantFilter',
    'filter.startDayFilter',
    'filter.endDayFilter',     
  ];
  export const filter = {
    'plantFilter': "",
    'startDayFilter': "",
    'endDayFilter': "",
  };